export default "uniform vec3 uLineColor;\n\nvoid main() {\n\n  vec3 color = uLineColor;\n\n  gl_FragColor = vec4(color, 1.0);\n\n}\n";